import { orchestrator } from 'satcheljs';
import { onLocaleChanged } from 'owa-localize';

orchestrator(onLocaleChanged, ({ locale }) => {
    if (document.documentElement.lang != locale) {
        document.documentElement.lang = locale;
    }
});
